import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import styled from "@emotion/styled";
import { FormErrorMessage } from "@shared/components/FormErrorMessage";

interface DateRangePickerProps {
  startValue?: Date | null;
  endValue?: Date | null;
  onStartChange?: (date: Date | null) => void;
  onEndChange?: (date: Date | null) => void;
  startLabel?: string;
  endLabel?: string;
  startError?: string | null;
  endError?: string | null;
  label?: string;
}

const StyledDatePicker = styled(DatePicker)({
  "& .MuiInputAdornment-root": {
    marginRight: "0.75rem",
  },
});

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startValue,
  endValue,
  onStartChange,
  onEndChange,
  startLabel = "Start Date",
  endLabel = "End Date",
  startError,
  endError,
  label,
}) => {
  return (
    <Box>
      {label && (
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
          {label}
        </Typography>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <StyledDatePicker
            label={startLabel}
            value={startValue}
            onChange={onStartChange}
            slotProps={{
              textField: {
                fullWidth: true,
                error: !!startError,
              },
            }}
            maxDate={endValue || undefined}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledDatePicker
            label={endLabel}
            value={endValue}
            onChange={onEndChange}
            slotProps={{
              textField: {
                fullWidth: true,
                error: !!endError,
              },
            }}
            minDate={startValue || undefined}
          />
        </Grid>
      </Grid>
      <FormErrorMessage>{startError || endError || " "}</FormErrorMessage>
    </Box>
  );
};
